<template>
  <v-card
                :loading="showDialogProgress"
                :disabled="showDialogProgress"
              >
  <div class="ExtraWorkRequest">
    <box class="" :title="this.$t('nav-request-extra-work')">
      <div class="px-3 pt-2">
        <v-form ref="form" v-model="form">
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("fromDate") }} : </label>
                </v-col>
                <v-col>
                  <dialog-date-picker
                    :label="$t('fromDate') + ':'"
                    :initDate="initBeginDate"
                    @dateResult="bDate"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("toDate") }} : </label>
                </v-col>
                <v-col>
                  <dialog-date-picker
                    :label="$t('toDate') + ':'"
                    :initDate="initEndDate"
                    @dateResult="eDate"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("fromTime") }} : </label>
                </v-col>
                <v-col>
                  <dialog-time-picker
                    :label="$t('fromTime') + ':'"
                    :initTime="initBeginTime"
                    @dateResult="bTime"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6">
              <v-row class="mt-2 mt-sm-0">
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("toTime") }} : </label>
                </v-col>
                <v-col>
                  <dialog-time-picker
                    :label="$t('toTime') + ':'"
                    :initTime="initEndTime"
                    @dateResult="eTime"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="12">
              <v-row>
                <v-col class="max-width-text-title px-1 d-flex">
                  <label class="my-auto">{{ $t("description") }} : </label>
                </v-col>
                <v-col>
                  <v-textarea
                    solo
                    dense
                    hide-details=""
                    ref="description"
                    v-model="eworkParams.Description"
                    auto-grow
                    :placeholder="$t('description')"
                    rows="2"
                  ></v-textarea>
                  <!-- <span >{{ eworkParams.Description.length }} / 250</span> -->
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>

        <v-card-actions class="px-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="showWorkCalndar = !showWorkCalndar">{{
            $t("workCalendar")
          }}</v-btn>
          <v-btn
            color="primary"
            :disabled="!form"
            :loading="isLoading"
            @click="addExtraWork"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </div>
    </box>

    <WorkCalendar :showWorkCalndar="showWorkCalndar" :perno="perno" />
  </div>
  </v-card>
</template>

<script>
import WorkCalendar from "../../components/request/WorkCalendar.vue";
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import DateUtils from "../../utils/DateUtils";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    WorkCalendar,
    DialogDatePicker,
    DialogTimePicker,
  },
  mounted() {
    this.checkDescriptionRules();
    this.getArgs();
  },
  data() {
    return {
      args: {},
      perno: "",
      ewDetails: {},
      eworkParams: {},
      showWorkCalndar: false,
      form: false,
      isLoading: false,
      showDialogProgress: false,
      initBeginDate: null,
      initBeginTime: null,
      beginDate: "",
      initEndDate: null,
      initEndTime: null,
      endDate: "",
      beginTime: "",
      endTime: "",
      desciption:"",
    };
  },
  methods: {
    getArgs() {
      this.args = this.$route.params.details;
      if (this.args) {
        this.loadRegistration(this.args);
      }

      if (this.args && this.args.selectedPerno) {
        this.perno = this.args.selectedPerno;
      }

      var selectedDate = this.$route.query.SD;
      if (selectedDate) {
        this.initBeginDate = this.beginDate = selectedDate;
        this.initEndDate = this.endDate = selectedDate;
      }
    },
    loadRegistration(args) {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(args.PageNo));
      params.append("dbkind", args.DBKind);
      params.append("year", args.Year);
      params.append("perno", args.selectedPerno || "");
      params.append("isGetForEdit", true);

      this.$store.dispatch("GetExtraWorkDetail", { params }).then((result) => {
        if (result.type == "success") {
          if (result.data.Table.length > 0) {
            this.ewDetails = result.data.Table[0];
            this.ewDetails.Year = args.Year;
            this.ShowExtraWorkDetailForEdit(this.ewDetails);
          }
        }
      });
    },
    ShowExtraWorkDetailForEdit(details) {
      this.eworkParams.pageNo = details.pageno.toString().trim();
      this.eworkParams.Description = details.userDescription;

      this.initBeginDate = this.beginDate = details.beginDate;
      this.initEndDate = this.endDate = details.endDate;
      this.initBeginTime = this.beginTime = details.beginTime;
      this.initEndTime = this.endTime = details.endTime;
    },
    bDate(date) {
      this.beginDate = date;
    },
    eDate(date) {
      this.endDate = date;
    },
    bTime(date) {
      this.beginTime = date;
    },
    eTime(date) {
      this.endTime = date;
    },
    addExtraWork() {
      this.showDialogProgress = true;
      //empty date
      if (!this.beginDate || !this.endDate) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.wrongDate"),
        });
        this.showDialogProgress = false;
        return;
      }

      //empty time
      if (!this.beginTime || !this.endTime) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.wrongTime"),
        });
        this.showDialogProgress = false;
        return;
      }

      //dateMustbeinSameYear
      if (this.beginDate.substr(0, 4) != this.endDate.substr(0, 4)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.dateMustbeinSameYear"),
        });
        this.showDialogProgress = false;
        return;
      }

      //CompareDates
      if (DateUtils.CompareDates(this.beginDate, this.endDate) != 1) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.CompareDates"),
        });
        this.showDialogProgress = false;
        return;
      }

      //CompareTimes
      if (
        this.beginDate + " " + this.beginTime >=
        this.endDate + " " + this.endTime
      ) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.CompareTimes"),
        });
        this.showDialogProgress = false;
        return;
      }

      if (this.beginDate == this.endDate) {
        if (this.beginTime >= this.endTime) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("eosWinKartWebResource.CompareTimes"),
          });
          this.showDialogProgress = false;
          return;
        }
      }

      //over 24 hours
      var moment = require("jalali-moment");
      var a = moment(
        this.beginDate + "-" + this.beginTime,
        "jYYYY/jMM/jDD-hh:mm"
      ).locale("fa");

      var b = moment(
        this.endDate + "-" + this.endTime,
        "jYYYY/jMM/jDD-hh:mm"
      ).locale("fa");

      var diff = b.diff(a, "hours");
      if (diff > 24) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "مدت زمان اضافه کار بیش از 24 ساعت است",
        });
        this.showDialogProgress = false;
        return;
      }

      //description length
      if (
        this.eworkParams.Description &&
        this.eworkParams.Description.trim().length > 250
      ) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "طول توضیحات نمی تواند بیش از 250 کارکتر باشد",
        });
        this.showDialogProgress = false;
        return;
      }

      const params = new URLSearchParams();
      params.append("beginDate", this.beginDate);
      params.append("beginTime", this.beginTime);
      params.append("endDate", this.endDate);
      params.append("endtime", this.endTime);
      params.append("userDescription", this.eworkParams.Description || "");

      if (this.eworkParams.pageNo) {
        params.append("pageNo", this.eworkParams.pageNo);
        params.append("perno", this.args.selectedPerno);

        this.$store.dispatch("UpdateExtraWork", { params }).then((result) => {
          if (result.type === "success") {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("msg-registration-success", {
                opName: this.$t("nav-request-extra-work"),
              }),
            });
            this.$refs.form.reset();
            if (this.args && this.args.from) {
              this.$router.push({ name: this.args.from });
            }
            this.showDialogProgress = false;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
            this.showDialogProgress = false;
          }
        });
      } else {
        this.$store.dispatch("InsertExtraWork", { params }).then((result) => {
          if (result.type === "success") {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("msg-registration-success", {
                opName: this.$t("nav-request-extra-work"),
              }),
            });
            this.$refs.form.reset();
            this.showDialogProgress = false;
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
            this.showDialogProgress = false;
          }
        });
      }
    },
    checkDescriptionRules() {
      var IsCommentRequired =
        this.$store.state.settings.settings.IsCommentRequiredForExtraWork;
      if (IsCommentRequired == 1) {
        this.$refs.description.rules = [this.$rules.required];
      }
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  max-width: 80px;
}
</style>